import { render, staticRenderFns } from "./traveller-2024-list.vue?vue&type=template&id=3556f620&scoped=true&"
import script from "./traveller-2024-list.vue?vue&type=script&lang=js&"
export * from "./traveller-2024-list.vue?vue&type=script&lang=js&"
import style0 from "./traveller-2024-list.vue?vue&type=style&index=0&id=3556f620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3556f620",
  null
  
)

export default component.exports